import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseActivityTargetForm from '../../../components/forms/ExerciseActivityTargetForm';
import { useExerciseActivityTargetApi } from '../../../hooks/useExerciseActivityTargetApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ExerciseActivityTargetDTO } from '../../../services/apiClient';

const ExerciseActivityTargetCreate: React.FC = () => {
  const { create, isLoading } = useExerciseActivityTargetApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Activity Targets', href: '/admin/exerciseactivitytargets' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ExerciseActivityTargetDTO) => {
    try {
      await create(data);
      navigate('/admin/exerciseactivitytargets');
    } catch (error) {
      console.error('Error creating Exercise Activity Target:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exerciseactivitytargets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ExerciseActivityTarget.Edit'
    >
        <ExerciseActivityTargetForm
          initialValues={{isUrl: true} as ExerciseActivityTargetDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/exerciseactivitytargets')}
        />
    </AdminLayout>
  );
};

export default ExerciseActivityTargetCreate;